import Axios from "axios";

Axios.defaults.baseURL = process.env.VUE_APP_API;

export default function interceptorSetup() {
  Axios.interceptors.request.use(
    function (config) {
      config.headers["Content-Type"] = "application/json";
      config.headers["Access-Control-Allow-Origin"] = "*";
      return config;
    },
    function (err) {
      return Promise.reject(err);
    }
  );
}
